const POSTHOG_PROXY_HOST = 'https://tdms.docomondo.com';
const POSTHOG_UI_HOST_DEFAULT = 'https://eu.posthog.com';

export const POSTHOG_API_HOST = process.env.NEXT_PUBLIC_POSTHOG_API_HOST || POSTHOG_PROXY_HOST;
export const POSTHOG_UI_HOST = process.env.NEXT_PUBLIC_POSTHOG_UI_HOST || POSTHOG_UI_HOST_DEFAULT;

export const isLocalhost = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  return (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '[::1]'
  );
};

export const isPostHogDisabled = () =>
  process.env.NEXT_PUBLIC_DISABLE_POSTHOG === 'true' || isLocalhost();

export const posthogPersistenceForConsent = (consent: string) =>
  consent === 'accepted' || consent === 'yes' ? 'localStorage+cookie' : 'memory';
